import type { ReactNode } from 'react';

import * as S from './style';

interface Props {
  children: ReactNode;
  onClick: () => void;
  isActive?: boolean;
}

export function Tool({ children, onClick, isActive = false }: Props) {
  return (
    <S.Button onClick={onClick} isActive={isActive} type='button'>
      {children}
    </S.Button>
  );
}
